import { EventEmitter, Injectable, NgZone } from "@angular/core";
import { HttpService } from "./http.service";
import { Observable } from "rxjs";
import { News } from "../model/models";
import { StorageService, StorageEvent } from "./storage.service";
import { LibraryItem } from "../model/library";
import { InformationService } from "./information.service";

@Injectable({
  providedIn: 'root'
})
export class LibraryService {

  bookingChange: EventEmitter<any> = new EventEmitter();
  maxBookingCount: number = 4;

  constructor(
    private http: HttpService,
    private storageService: StorageService,
    private informationService: InformationService,
    private zone: NgZone
  ) {
    // Получаем максимум бронирования
    this.informationService.getServiceInfo()
      .subscribe((res) => {
        const count = res.results.find((value: any) => value.name === 'max_book_count')?.value;
        if (count) this.maxBookingCount = count;
      });

    // Подписка на изменения bookingItems из других вкладок
    this.storageService.watch().subscribe((event: StorageEvent) => {
      if (!event.external) return;
      if (event.key === 'bookingItems' || event.type === 'clear') {
        this.zone.run(() => {
          this.bookingChange.emit(this.getItemsFromBookStorage());
        });
      }
    });
  }

  /** HTTP методы */
  getLibraryItems(params: any): Observable<News> {
    return this.http.get(`api/library-items/`, params);
  }

  getLibraryItemInfo(id: any): Observable<News> {
    return this.http.get(`api/library-items/${id}/`, {});
  }

  checkLibrarySubscription(email: string): Observable<any> {
    return this.http.get('api/library-users/status', { email });
  }

  unsubscribeLibrary(email: string): Observable<any> {
    return this.http.post('api/library-users/deactivate', { email });
  }

  bookedRequest(email: string, items: LibraryItem[]): Observable<any> {
    return this.http.post("api/library/booked_request", { email, items });
  }

  getCategories(): Observable<any> {
    return this.http.get('api/library-categories/', { limit: 100 });
  }

  /** Работа с local sessionStorage и событием bookingChange */
  addItemToBookStorage(item: LibraryItem) {
    let items: LibraryItem[] = this.storageService.getItem('bookingItems', '[]');

    const exists = items.some(current => current.id === item.id);
    if (exists) {
      this.bookingChange.emit({ type: 'error', message: 'Книга уже добавлена для бронирования' });
      return;
    }

    if (items.length < this.maxBookingCount) {
      items.push(item);
      this.storageService.setItem(items, 'bookingItems');
      this.bookingChange.emit(items);
    } else {
      this.bookingChange.emit({ type: 'error', message: `Забронировать одновременно можно только ${this.maxBookingCount} книги` });
    }
  }

  removeItemFromBookStorage(item: LibraryItem) {
    let items: LibraryItem[] = this.storageService.getItem('bookingItems', '[]');
    items = items.filter(current => current.id !== item.id);
    this.storageService.setItem(items, 'bookingItems');
    this.bookingChange.emit(items);
  }

  setItemsToBookStorage(items: LibraryItem[]) {
    this.storageService.setItem(items, 'bookingItems');
    this.bookingChange.emit(items);
  }

  getItemsFromBookStorage(): LibraryItem[] {
    return this.storageService.getItem('bookingItems', '[]');
  }

  clearBooking() {
    this.storageService.deleteItem('bookingItems');
    this.bookingChange.emit([]);
  }
}
